import { Tabs as BaseTabs } from "@base-ui/react/tabs";
import type { ReactNode } from "react";
import { cx } from "../presentation.tsx";

export interface TabItem { value: string; label: ReactNode; content: ReactNode; disabled?: boolean }

export interface TabsProps {
  items: TabItem[];
  /** Accessible name of the tab list. */
  label: string;
  value?: string;
  defaultValue?: string;
  onValueChange?: (value: string) => void;
  className?: string;
}

export function Tabs({ items, label, value, defaultValue, onValueChange, className }: TabsProps) {
  return (
    <BaseTabs.Root
      className={cx("pmu-tabs", className)} value={value} defaultValue={defaultValue ?? items[0]?.value}
      onValueChange={onValueChange ? (v) => onValueChange(String(v)) : undefined}
    >
      <BaseTabs.List className="pmu-tabs__list" aria-label={label}>
        {items.map((t) => (
          <BaseTabs.Tab key={t.value} value={t.value} disabled={t.disabled} className="pmu-tabs__tab">{t.label}</BaseTabs.Tab>
        ))}
        <BaseTabs.Indicator className="pmu-tabs__indicator" />
      </BaseTabs.List>
      {items.map((t) => (
        <BaseTabs.Panel key={t.value} value={t.value} className="pmu-tabs__panel">{t.content}</BaseTabs.Panel>
      ))}
    </BaseTabs.Root>
  );
}
